import React, { useEffect } from 'react';

const ServiceSchema = ({ service }) => {
  const baseUrl = 'https://cyborgsapient.com';
  const serviceUrl = `${baseUrl}/services/${service.slug}`;

  useEffect(() => {
    // Update document title and meta tags
    document.title = service.metaTitle;
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = service.metaDescription;

    // Update or create keywords meta tag
    if (service.keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = service.keywords;
    }

    // Create or update OG tags
    const ogTags = {
      'og:title': service.metaTitle,
      'og:description': service.metaDescription,
      'og:url': serviceUrl,
      'og:type': 'website',
      'og:image': `${baseUrl}/assets/images/logo.png`
    };

    Object.entries(ogTags).forEach(([property, content]) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    });

    // Create or update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = serviceUrl;

    // Remove existing service schema script if any
    const existingSchema = document.querySelector('script[type="application/ld+json"][data-service-schema]');
    if (existingSchema) {
      existingSchema.remove();
    }

    // Create service schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": service.title,
      "description": service.shortDesc,
      "url": serviceUrl,
      "provider": {
        "@type": "Organization",
        "name": "Cyborg Sapient",
        "url": baseUrl,
        "logo": `${baseUrl}/assets/images/logo.png`,
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+91-9164752256",
          "contactType": "customer service",
          "email": "contact@cyborgsapient.com"
        },
        "address": [
          {
            "@type": "PostalAddress",
            "streetAddress": "Pooja Garden, Kalkere",
            "addressLocality": "Bangalore",
            "addressCountry": "IN"
          },
          {
            "@type": "PostalAddress",
            "streetAddress": "7901 4th St N #21879",
            "addressLocality": "St Petersburg",
            "addressRegion": "FL",
            "postalCode": "33702",
            "addressCountry": "US"
          }
        ]
      },
      "areaServed": "IN",
      "serviceType": service.title,
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": `${service.title} Services`,
        "itemListElement": service.features.map((feature) => ({
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": feature
          }
        }))
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-service-schema', 'true');
    script.textContent = JSON.stringify(serviceSchema);
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, [service, serviceUrl]);

  return null;
};

export default ServiceSchema;

